<script>
import Layout from "../../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import { projectService } from "../../../../services/projectservice/project.service";
// import { settingService } from "../../../../services/settingservice/setting.service";
import List from "../../../../components/list";
import i18n from "../../../../i18n";
/* eslint-disable no-console */
/**
 * Contacts-list component
 */
export default {
  page: {
    title: "Project List",
    meta: [{ name: "description", content: appConfig.description }]
  },
  components: { Layout, PageHeader, List },
  data() {
    return {
      projectList: {},

      fetchingStats: false,
      title: "Project List",

    };
  },
  mounted() {
    
    this.loadingData();
  },

  methods: {
    loadingData: function(param = '') {
      this.fetchingStats = false;
      projectService.getList(param)
        .then(response => {
          
          this.fetchingStats = true;
          this.projectList = response;
        });
    },

    deleted: function(id) {
      projectService.remove(id)
        .then(response => {
        
          // this.customerData = response;
          if(response.status == 200) {
            this.$swal.fire({
              title: i18n.t('general.confirm.deleted'),
              text: i18n.t('general.confirm.success'),
              icon: "success",
              confirmButtonText: i18n.t('general.ok')
            });
          }
        });
    },

    pageNavigate: function(param) {
      this.loadingData(param);
    },

    submitAdd: function() {
      this.$router.push(this.$route.query.redirectFrom || {
              name: "setting-project-add",
          });
    },

  }
};
</script>

<template>
  <Layout>
    <PageHeader :add="{icon: 'bx bx-add-to-queue bx-tada', title: 'general.new', link: 'setting-project-add'}" :title="$t('project.text')" />
    <List v-bind:dataList="projectList" 
          v-bind:updating="fetchingStats" 
          v-bind:navigate="pageNavigate"
          v-bind:view="{link: 'project-summary-id'}"
          v-bind:formats="[]"
          v-bind:fields="[`code: ${$t('project.code')}`, `name: ${$t('project.name')}`, 
            `phone_no_1: ${$t('project.phone-no-1')}`, `address: ${$t('seller.address')}`]" 
          v-bind:deletes="[deleted, null]"
          v-bind:edit="{link: 'setting-project-edit'}"
          v-bind:filter="{
            search: ['loan_templates.name', 'loan_templates.name_en'],
            dropdown: []

          }"
          
    />      
  </Layout>
</template>